import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// Only Bootstrap's reset (Reboot), not the framework: no Bootstrap class is used
// anywhere, but the site does rely on the reset's element rules - smooth
// in-page scrolling (ScrollToTop), paragraph and heading margins, link colours,
// the faded <hr> behind MUI Dividers. The full sheet was 232 KB of classes
// matched against every element on every style recalculation.
import "bootstrap/dist/css/bootstrap-reboot.min.css";


import Theme from "../src/styles/Theme/Theme";
import { ThemeProvider, CssBaseline } from "@mui/material";
import MotionProvider from "./components/Motion/MotionProvider";
import { preloadRoute } from "./routes/routeChunks";

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = () =>
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <MotionProvider>
          <App />
        </MotionProvider>
      </ThemeProvider>
    </React.StrictMode>
  );

// A visit that starts on a split page renders once that page's code is here, so
// the first render is the page itself rather than an empty placeholder that
// fills in a moment later. Home needs no chunk and renders immediately. If the
// chunk fails, render anyway: the route retries the load itself.
preloadRoute(window.location.pathname).then(render, render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
